import { UserRound } from 'lucide-react'
import './Avatar.css'

const GLYPH_SIZE = { sm: 15, md: 19, lg: 24 }

/**
 * A person mark.
 *
 * The legacy panel renders Metronic's `blank.png` for every user, so there is no
 * photo to show. This used to fall back to initials, which read as data the row
 * did not have — two letters of a name already printed beside them. A glyph says
 * "person" and lets the name do the identifying; every disc wears the same neutral
 * grey (Avatar.css).
 *
 * @param {string} [name]  still passed by callers; the mark no longer draws from it
 * @param {'sm'|'md'|'lg'} [size]
 * @param {boolean} [solid]  the signed-in user — accent fill rather than tint
 */
export default function Avatar({ size = 'md', solid = false, className = '' }) {
  const classes = [
    'avatar',
    `avatar--${size}`,
    solid && 'avatar--solid',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <span className={classes} aria-hidden="true">
      <UserRound size={GLYPH_SIZE[size]} strokeWidth={1.75} />
    </span>
  )
}
